import { createService } from '@/helpers/hasura'

const allowedFields = ['description', 'tags']
const output = `
    id
    created_at
    updated_at
    description
    tags
`

export default config => {
  const service = createService({
    ...config,
    table: 'item_tag_stat_watch',
    defaultPageSize: 25,
    defaultOrderBy: [{ description: 'asc' }],
    defaultSearchBy: ['description'],
    defaultFilters: [],
    uniqueFields: [],
    defaultOutput: output,
    allowedFields
  })

  return {
    ...service
  }
}
